import { routeRules } from './rules';
import type { BreadcrumbContext, BreadcrumbResult, RouteRule } from './types';
export class FunctionalBreadcrumbEngine {
  private rules: RouteRule[] = routeRules;

  generate(context: BreadcrumbContext): BreadcrumbResult {
    const defaultBackLink = context.isMobile ? undefined : 'home';

    const matchedRule = this.rules.find((rule) => rule.match(context.path));

    if (!matchedRule) {
      return {
        breadcrumbs: [{ label: context.t('Unknown Page') }],
        backLink: defaultBackLink,
      };
    }

    const breadcrumbs = matchedRule.generate(context);
    const styledBreadcrumbs = this.applyStyles(breadcrumbs, context.path);
    const backLink = matchedRule.backLink ? matchedRule.backLink(context) : defaultBackLink;

    return {
      breadcrumbs: styledBreadcrumbs,
      backLink,
    };
  }
  private applyStyles(breadcrumbs: any[], currentPath: string) {
    if (breadcrumbs.length === 0) return breadcrumbs;

    return breadcrumbs
      .map((breadcrumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        const isCurrentPath = !breadcrumb.link || breadcrumb.link === currentPath;

        return {
          ...breadcrumb,
          linkClass: isLast
            ? 'text-primary font-medium cursor-default'
            : isCurrentPath
              ? 'text-text-03 cursor-default'
              : breadcrumb.linkClass,
        };
      })
      .filter(Boolean);
  }

  extend(newRules: RouteRule[]) {
    return new FunctionalBreadcrumbEngine().setRules([...this.rules, ...newRules]);
  }

  setRules(rules: RouteRule[]) {
    const engine = new FunctionalBreadcrumbEngine();
    engine.rules = rules.sort((a, b) => (b.priority || 0) - (a.priority || 0));
    return engine;
  }
  getRules() {
    return [...this.rules];
  }
}

export const breadcrumbEngine = new FunctionalBreadcrumbEngine();
